import { useState, type FormEvent } from 'react';
import { useSession } from '../auth/session.js';
import { useBusinessAccounts } from '../business/scope.js';

type CsvIssue = { readonly row?: number; readonly field: string; readonly message: string };

export const ContactsRoute = () => {
  const { account } = useBusinessAccounts();
  const { csrfToken } = useSession();
  const [issues, setIssues] = useState<readonly CsvIssue[]>([]);
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (account === null) return;
    const element = event.currentTarget;
    setBusy(true); setIssues([]); setMessage(null);
    try {
      const form = new window.FormData(element);
      form.set('businessAccountId', account.id);
      const result = await fetch('/api/v1/contacts/import', {
        method: 'POST', credentials: 'include', body: form,
        headers: { 'Idempotency-Key': crypto.randomUUID(), ...(csrfToken === null ? {} : { 'x-csrf-token': csrfToken }) },
      });
      const body = await result.json() as { error?: { details?: CsvIssue[] }; data?: { status?: string } };
      if (!result.ok) { setIssues(body.error?.details ?? [{ field: 'file', message: 'Arquivo inválido' }]); return; }
      setMessage('Importação recebida. O processamento continuará em segundo plano.');
    } catch { setIssues([{ field: 'file', message: 'Não foi possível enviar o arquivo.' }]); }
    finally { setBusy(false); }
  };
  return <section><header className="page-heading"><div><h1>Contatos</h1><p>Importe consentimento comprovável; nenhuma linha inválida é gravada.</p></div></header>
    <form className="operation-form" onSubmit={(event) => void submit(event)}>
      <label htmlFor="contacts-csv">Arquivo CSV</label><input id="contacts-csv" name="file" type="file" accept=".csv,text/csv" required aria-describedby={issues.length === 0 ? 'csv-help' : 'csv-errors'} />
      <p id="csv-help">Máximo de 10 MB e 10.000 linhas. Inclua data, origem e referência do consentimento.</p>
      <button type="submit" disabled={busy || account === null}>{busy ? 'Enviando…' : 'Validar e importar'}</button>
    </form>
    {issues.length === 0 ? null : <div id="csv-errors" role="alert" className="error-list">{issues.map((issue, index) => <p key={String(issue.row) + issue.field + String(index)}>{issue.row === undefined ? '' : 'Linha ' + String(issue.row) + ' — '}{issue.field}: {issue.message}</p>)}</div>}
    {message === null ? null : <p role="status" className="success-line">{message}</p>}
  </section>;
};
